import API from 'utils/API'
import config from 'app/config'

export const fetchSocialMedia = params => (
  () => new Promise((resolve, reject) => (
    API.get(`/dashboard/social-media${params || ''}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const createSocialMedia = payload => (
  () => new Promise((resolve, reject) => (
    API.post('/dashboard/social-media', payload).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const fetchSocialMediaDetail = id => (
  () => new Promise((resolve, reject) => (
    API.get(`/dashboard/social-media/${id}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const updateSocialMedia = (id, payload) => (
  () => new Promise((resolve, reject) => (
    API.put(`/dashboard/social-media/${id}`, payload).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)


export const deleteSocialMedia = id => (
  () => new Promise((resolve, reject) => (
    API.delete(`/dashboard/social-media/${id}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const webFetchSocialMedia = params => (
  () => new Promise((resolve, reject) => (
    API.get(
      `/web/social-media${params || ''}`,
      { headers: { Authorization: `Bearer ${config.api_key}` } },
    ).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)
